import { computed, onBeforeUnmount, reactive, watch } from 'vue'

const modalState = reactive<Map<string, boolean>>(new Map())

const showModalFn = (name: string) => {
  if (modalState.has(name)) {
    return
  }

  modalState.set(name, true)
}

const hideModalFn = (name: string) => {
  if (!modalState.has(name)) {
    return
  }

  modalState.delete(name)
}

// rgba(15, 23, 42, 0.9) flattened onto white; theme-color ignores alpha.
const handleThemeColor = (shouldBeDark: boolean) => {
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', shouldBeDark ? 'rgb(39, 46, 63)' : 'rgb(255, 255, 255)')
}

watch(modalState, () => {
  const isOpen = modalState.size > 0

  if (window.innerWidth < 640) {
    handleThemeColor(isOpen)
  }

  document.body.classList.toggle('modal-open', isOpen)

  // The dialog is teleported next to the wrapper, so inerting the wrapper keeps
  // both the pointer and the tab order inside the dialog.
  document.querySelector('.wrapper')?.toggleAttribute('inert', isOpen)
})

export const useModal = (name: string) => {
  const isModalShown = computed(() => !!modalState.get(name))

  const handleKeyEvent = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      hideModalFn(name)
    }
  }

  document.addEventListener('keydown', handleKeyEvent)

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', handleKeyEvent)
  })

  return {
    showModal: () => showModalFn(name),
    hideModal: () => hideModalFn(name),
    isModalShown,
  }
}

// A guest has nothing to upgrade yet, so they get the login-or-register modal instead.
export const showUpgradeModal = () => {
  showModalFn(window._state.subscriber ? 'upgrade-modal' : 'premium-login-or-register')
}
